import React from 'react'
import { Popover, Box, Paper } from '@mui/material'
import { PayPeriodData } from '../../../models/enhancement/pay-period-data'
import { usePayPeriodModal } from './hooks/usePayPeriodModal'
import YearNavigationHeader from './components/YearNavigationHeader'
import PayPeriodModalContent from './components/PayPeriodModalContent'

interface PayPeriodModalProps {
  open: boolean;
  anchorEl: HTMLElement | null;
  onClose: () => void;
  onSelect: (payPeriod: PayPeriodData) => void;
  payPeriodsByYear: Record<number, PayPeriodData[]>;
  availableYears: number[];
  selectedYear: number;
  onYearChange: (year: number) => void;
  isLoading?: boolean;
  error?: string | null;
  dataTestId?: string;
}

function PayPeriodModal({
  open,
  anchorEl,
  onClose,
  onSelect,
  payPeriodsByYear,
  availableYears,
  selectedYear,
  onYearChange,
  isLoading = false,
  error = null,
  dataTestId = 'pay-period-modal'
}: PayPeriodModalProps) {
  
  const {
    periodsForYear,
    canNavigateToPreviousYear,
    canNavigateToNextYear,
    navigateToPreviousYear,
    navigateToNextYear
  } = usePayPeriodModal({
    payPeriodsByYear,
    availableYears,
    selectedYear,
    onYearChange
  })

  const handleSelect = (payPeriod: PayPeriodData) => {
    onSelect(payPeriod)
    onClose()
  }

  return (
    <Popover
      open={open}
      anchorEl={anchorEl}
      onClose={onClose}
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'left',
      }}
      transformOrigin={{
        vertical: 'top',
        horizontal: 'left',
      }}
      data-testid={dataTestId}
    >
      <Paper sx={{ width: 400, maxHeight: 500 }}>
        <YearNavigationHeader
          selectedYear={selectedYear}
          canNavigateToPreviousYear={canNavigateToPreviousYear}
          canNavigateToNextYear={canNavigateToNextYear}
          navigateToPreviousYear={navigateToPreviousYear}
          navigateToNextYear={navigateToNextYear}
          isLoading={isLoading}
          dataTestId={`${dataTestId}-year-navigation`}
        />
        
        <Box sx={{ px: 1, py: 0.3 }}>
          <PayPeriodModalContent
            periodsForYear={periodsForYear}
            selectedYear={selectedYear}
            isLoading={isLoading}
            error={error}
            onSelect={handleSelect}
            dataTestId={dataTestId}
          />
        </Box>
      </Paper>
    </Popover>
  )
}

export default PayPeriodModal